var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { MapContainer } from 'react-leaflet';
import ManifestMap from "./ManifestMap";
import { Box, Typography } from "@mui/material";
export default function ManifestMapContainer(_a) {
    var manifests = _a.manifests, focus = _a.focus;
    var manifestsWithGeoJson = manifests.filter(function (manifest) { return manifest.navPlace(); });
    var mapStyle = {
        justifyContent: "center",
        width: "100%",
        height: "40vh",
        clear: "both",
        margin: "auto"
    };
    return manifestsWithGeoJson.length === 0 ?
        _jsx(Box, __assign({ sx: mapStyle }, { children: _jsx(Typography, { children: "No mappable items" }, void 0) }), void 0)
        :
            _jsx(MapContainer, __assign({ zoom: 2, style: mapStyle }, { children: _jsx(ManifestMap, { manifests: manifestsWithGeoJson, focus: focus }, void 0) }), void 0);
}
